import React, { useRef, useEffect } from 'react'
import { ReactComponent as ImQrcode } from "../../../Assets/img/icons/QrCode_AllCards.svg";
import { ReactComponent as IoMdShare } from "../../../Assets/img/icons/Share.svg";
import CardWaveStd from '../../Utilities/CardWaveStd';
import CardWaveSmile from '../../Utilities/CardWaveSmile2'
import CardWaveFlat from '../../Utilities/CardWaveFlat';
import CardWaveSlope from '../../Utilities/CardWaveSlope2';
import DefaultProfileBg from "../../../Assets/img/card/profilebg.png"
import { ReactComponent as CAIndialogo } from '../../../Assets/img/icons/ca-india-logo.svg'
// import HrOuterShape1 from '../../../Assets/img/card/hr-outer-shape-above.svg'
// import HrOuterShape2 from '../../../Assets/img/card/hr-outer-shape-below.svg'
// import HrInnerShape from '../../Utilities/HrInnerShape';
import HrInnerShape from '../../../Assets/img/card/hr-inner-shape.svg'
import HrOuterShape1 from '../../Utilities/HrOuterShape1';
import { ReactComponent as ITGridShape1 } from '../../../Assets/img/card/it-layout-shape-1.svg'
import { ReactComponent as ITGridShape2 } from '../../../Assets/img/card/it-layout-shape-2.svg'
import { ReactComponent as ITGridShape3 } from '../../../Assets/img/card/it-layout-shape-3.svg'
import { ReactComponent as ITGridShape4 } from '../../../Assets/img/card/it-layout-shape-4.svg'
import { ReactComponent as ITGridShape5 } from '../../../Assets/img/card/it-layout-shape-5.svg'
import { ReactComponent as BottomLight } from '../../../Assets/img/card/adv-layout-bottom-light.svg'
import { ReactComponent as TopLight } from '../../../Assets/img/card/adv-layout-top-light.svg'
import { ReactComponent as BottomBold } from '../../../Assets/img/card/adv-layout-bottom-bold.svg'
import { ReactComponent as TopBold } from '../../../Assets/img/card/adv-layout-top-bold.svg'
import QrCodeCard from './QrCodeCard';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
// import MailRoundedIcon from '@mui/icons-material/MailRounded';
import PublicIcon from '@mui/icons-material/Public';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import { EmailRounded } from '@material-ui/icons';
import { ReactComponent as NonVerifiedTickNew } from "../../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as VerifiedTickN } from "../../../Assets/img/icons/Verified-icon-new.svg";
import { useLocation } from 'react-router-dom';

// Non-personal Layouts : 1, 3, 5, 7 - Applicable to Professional, Student, and GenZ Cards
const Layout1 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor } = layoutProps;

    // console.log("This is company logo in the Preview", companyLogo?.data);

    return (
        <>
            <div className='preview-card-upper full-bg-cover' style={{ backgroundImage: `url(${profilePicture})` }}>
                <div className='digi-card-label-container truncate ' style={{ backgroundColor: layoutColor }}>
                    <span className='digi-card-label' style={{ color: labelColor }}> {cardType}</span>
                </div>
                <div>
                    <CardWaveStd bgColor={bgColor} strokeColor={layoutColor} />
                </div>

                {(cardType != "Personal" || cardType != "Customize_Personal") &&
                    <>
                        {(companyLogo && companyLogo.length !== 0) ? (
                            <div className='company-logo-container layout-1 new flex-center'>
                                <img className='contain-image' src={!companyLogo?.data ? companyLogo : companyLogo?.data} alt="companyLogo" srcset="" />
                            </div>
                        ) : (
                            <div className='company-logo-container flex-center'>
                                <img className='contain-image' src={DefaultProfileBg} alt='empty' />
                            </div>
                        )}
                    </>}

            </div>
            <div className='preview-card-names word-break' style={{ /*marginTop: "2.5em"*/ }}>
                <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {(cardType === "Professional" || cardType === "Customize_Professional") ? (companyName + " - " + designation) : (title)}</h5>
            </div>
        </>
    )
}

const Layout3 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor } = layoutProps;

    return (
        <>
            <div className='preview-card-upper full-bg-cover' style={{ backgroundImage: `url(${profilePicture})` }}>
                <div className='digi-card-label-container truncate ' style={{ backgroundColor: layoutColor }}>
                    <span className='digi-card-label' style={{ color: labelColor }}> {cardType}</span>
                </div>
                <div>
                    <div>
                        <CardWaveFlat bgColor={bgColor} strokeColor={layoutColor} />
                    </div>
                </div>

                {cardType != "Personal" &&
                    <>
                        {(companyLogo && companyLogo.length !== 0) ? (
                            <div className='company-logo-container layout-3 new flex-center'>
                                <img className='contain-image' src={!companyLogo?.data ? companyLogo : companyLogo?.data} alt="companylogo" />
                            </div>
                        ) : (
                            <div className='company-logo-container flex-center'>
                                <img src={DefaultProfileBg} alt='Logo' className='contain-image' />
                            </div>
                        )}
                    </>}

            </div>
            <div className='preview-card-names word-break' style={{ marginTop: "2.5rem" }}>
                <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {(cardType === "Professional" || cardType === "Customize_Professional") ? (companyName + " - " + designation) : (title)}</h5>
            </div>
        </>
    )
}

const Layout5 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, layoutColor, labelColor } = layoutProps;

    return (
        <>
            <div className='preview-card-upper layout-5'>
                <div className='digi-card-label-container truncate ' style={{ backgroundColor: layoutColor }}>
                    <span className='digi-card-label' style={{ color: labelColor }}> {cardType}</span>
                </div>
                <div className='layout-5-img-container'>
                    <div className='layout-images-wrapper'>
                        <img className='layout-profile-picture' src={profilePicture} alt="Profile" />
                        <div className='layout-logo-container flex-center' >
                            <img src={!companyLogo?.data ? companyLogo : companyLogo?.data} alt="Logo" />
                        </div>
                    </div>
                </div>

            </div>
            <div className='preview-card-names word-break'>
                <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {(cardType === "Professional" || cardType === "Customize_Professional") ? (companyName + " - " + designation) : (title)}</h5>
            </div>
        </>
    )
}

const Layout7 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor } = layoutProps;

    return (
        <>
            <div className='preview-card-upper layout-7 full-bg-cover' style={{ backgroundImage: `url(${profilePicture})` }}>
                <div className='digi-card-label-container truncate ' style={{ backgroundColor: layoutColor }}>
                    <span className='digi-card-label' style={{ color: labelColor }}> {cardType}</span>
                </div>
                <div>
                    <div>
                        <CardWaveSlope bgColor={bgColor} strokeColor={layoutColor} />
                    </div>

                    {cardType !== "Personal" &&
                        <>
                            {(companyLogo && companyLogo.length !== 0) ? (
                                <div className='company-logo-container layout-7 new flex-center'>
                                    <img className='contain-image' src={!companyLogo?.data ? companyLogo : companyLogo?.data} alt='Logo' />
                                </div>
                            ) : (
                                <div className='company-logo-container flex-center'>
                                    <img className='contain-image' src={DefaultProfileBg} alt='empty' />
                                </div>
                            )}
                        </>}
                </div>

            </div>
            <div className='preview-card-names word-break' style={{ marginTop: "2.5rem" }}>
                <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {(cardType === "Professional" || cardType === "Customize_Professional") ? (companyName + " - " + designation) : (title)}</h5>
            </div>
        </>
    )
}

// Personal Layouts : 2, 4, 6, 8

const Layout2 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, firstName, lastName, suffix,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, handleOpenDialog, handleShareClick, isVerified, isOwner } = layoutProps;

    const location = useLocation();
    const isDigitalIdentity = location.pathname.includes("/digital-identity/");
    return (<>
        <div className='preview-card-upper full-bg-cover layout-2' style={{ backgroundImage: `url(${profilePicture})` }}>
            <div className='digi-card-label-container truncate ' style={{ backgroundColor: layoutColor }}>
                <span className='digi-card-label' style={{ color: labelColor }}> {cardType}</span>
            </div>
            <div>
                <div>
                    <CardWaveSmile bgColor={bgColor} strokeColor={layoutColor} />
                </div>
            </div>

            <div>
                <div className="icons_share_qr icon-alignment-card smile-share-icons">
                    {!isDigitalIdentity && (
                        <div className='icon-border me-3 flex-center' style={{ borderColor: layoutColor }}>
                            <ImQrcode className='icon-color' onClick={handleOpenDialog} />
                        </div>
                    )}
                    {!isDigitalIdentity && <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: layoutColor }}>
                        {/* {isVerified === true ? <verifiedTickN /> : <NonVerifiedTickNew />} */}
                        {isVerified === true ?
                            <VerifiedTickN title="Verified" /> :
                            <NonVerifiedTickNew title="Not Verified" />
                        }
                    </div>}
                    {!isDigitalIdentity && (
                        <div className='icon-border flex-center' style={{ borderColor: layoutColor }}>
                            <IoMdShare className='icon-color' onClick={handleShareClick} />
                        </div>
                    )}
                </div>
                {/* </div> */}
            </div>

        </div>
        <div className='preview-card-names word-break text-center' style={{ marginTop: "2.5em" }}>
            <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
            <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {title}</h5>
        </div>

        {/* <div className="mt-2 line-card">
                <div className="line-blue" style={{ backgroundColor: layoutColor }}></div>
                <div className="icons_share_qr icon-alignment-card d-flex align-items-center justify-content-center gap-2">
                    <div className='icon-border me-3 flex-center' style={{ borderColor: layoutColor }}>
                        <ImQrcode className='icon-color' onClick={handleOpenDialog} />
                    </div>
                    <div className='icon-border ms-3 flex-center' style={{ borderColor: layoutColor }}>
                        <IoMdShare className='icon-color' onClick={handleShareClick} />
                    </div>
                </div>
            </div> */}
    </>
    )
}

const Layout4 = ({ layoutProps }) => {
    const { profilePicture, cardType, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor } = layoutProps;

    return (
        <>
            <div className='preview-card-upper layout-4 full-bg-cover' style={{ backgroundImage: `url(${profilePicture})` }}>
                <div className='digi-card-label-container truncate ' style={{ backgroundColor: layoutColor }}>
                    <span className='digi-card-label' style={{ color: labelColor }}> {cardType}</span>
                </div>
                <div>
                    <div>
                        <CardWaveSmile bgColor={bgColor} strokeColor={layoutColor} />
                    </div>
                </div>
                <div className='flex-center w-100pc'>
                    <div className='layout-name-box' style={{ maxWidth: "90%", position: "absolute", borderRadius: "8px", backgroundColor: "#F5F8FD", bottom: "-50px" }} >
                        <div className='preview-card-names word-break text-center'>
                            <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                            <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {(cardType === "Professional" || cardType === "Customize_Professional") ? (companyName + " - " + designation) : (title)}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const Layout6 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor } = layoutProps;

    return (
        <>
            <div className='preview-card-upper layout-6'>
                <div className='digi-card-label-container truncate ' style={{ backgroundColor: layoutColor }}>
                    <span className='digi-card-label' style={{ color: labelColor }}> {cardType}</span>
                </div>

                {/* <div className='layout-logo-container' style={{ position: "absolute", height: "55px", width: "55px", borderRadius: "4px", backgroundColor: "#ffffff", right: "16px", top: "16px" }} >
                        <img src={companyLogo} alt="Logo" style={{ height: "100%", width: "90%", borderRadius: "50%", backgroundColor: "#ffffff", objectFit: "contain" }} />
                </div> */}

                <div className='layout-6-img-container mt-4'>
                    <div className='layout-images-wrapper align-items-center'>
                        <div className='layoutout6-changes'>
                            <img className='layout-profile-picturelayout6 d-flex' src={profilePicture} alt="Profile" />
                        </div>
                        <div className='layout-6-decor-line' style={{ backgroundColor: layoutColor }} />
                    </div>
                </div>

            </div>
            <div className='preview-card-names word-break text-center'>
                <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {(cardType === "Professional" || cardType === "Customize_Professional") ? (companyName + " - " + designation) : (title)}</h5>
            </div>

            {/* <div className="mt-2 line-card">
                <div className="line-blue" style={{ backgroundColor: layoutColor }}></div>
                <div className="icons_share_qr icon-alignment-card d-flex align-items-center justify-content-center gap-2">
                    <div className='icon-border me-3 flex-center' style={{ borderColor: layoutColor }}>
                        <ImQrcode className='icon-color' onClick={handleOpenDialog} />
                    </div>
                    <div className='icon-border ms-3 flex-center' style={{ borderColor: layoutColor }}>
                        <IoMdShare className='icon-color' onClick={handleShareClick} />
                    </div>
                </div>
            </div>

            <div className='summary-container'>
                {summary}
            </div> */}
        </>
    )
}

const Layout8 = ({ layoutProps }) => {
    const { profilePicture, cardType, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, layoutColor, labelColor } = layoutProps;

    return (
        <>
            <div className='preview-card-upper layout-8'>
                <div className='digi-card-label-container truncate ' style={{ backgroundColor: layoutColor }}>
                    <span className='digi-card-label' style={{ color: labelColor }}> {cardType}</span>
                </div>

                <div className='layout-8-img-container'>
                    <div className='layout-images-wrapper flex-column align-items-center'>
                        <img className='layout-profile-picture' src={profilePicture} alt="Profile" />
                        <div className='layout-name-box' >
                            <div className='preview-card-names word-break text-center'>
                                <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {(cardType === "Professional" || cardType === "Customize_Professional") ? (companyName + " - " + designation) : (title)}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className='preview-card-names word-break'>
                <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}</h3>
                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {cardType === "Professional" ? (companyName + " - " + designation) : (title)}</h5>
            </div> */}
        </>
    )
}

const LayoutCa1 = ({ layoutProps }) => {
    const { prefix, firstName, lastName, suffix,
        companyName, designation, colorPrimary, cardType,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address, userDetails } = layoutProps;

    return (
        <>
            <div className="layout-prof ca-layout-1" style={{ backgroundColor: "white" }}>
                <div className="ca-layout-upper py-2 px-2">
                    <div className='flex-center ps-1'>
                        <CAIndialogo />
                    </div>
                    <div className='preview-card-names' >
                        <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails?.name}</h3>
                        <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {companyName + " - " + designation}</h5>
                    </div>
                </div>
                <div className="ca-layout-body px-2">
                    <div className="d-flex justify-content-between">
                        <div className="flex-center ca-layout-left">
                            <div>
                                <QrCodeCard CARDNAME_id={cardType} size={100} />
                            </div>
                        </div>
                        <div className='ca-layout-right'>
                            <div className="d-flex flex-column justify-content-end py-3 pe-2">
                                <div className="d-flex justify-content-end align-items-center mb-2 gap-2">
                                    <div>{phoneNo}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PhoneIphoneRoundedIcon className='ca-contact-svg' /> </div>
                                </div>
                                <div className="d-flex justify-content-end align-items-center mb-2 gap-2">
                                    <div>{emailId}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                </div>
                                {(website && website?.visible) ?
                                    <a href={website.url} target='_blank' rel='noreferrer'
                                        className="d-flex justify-content-end align-items-center mb-2 gap-2"
                                        style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}>
                                        <div>My Website</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='ca-contact-svg' /></div>
                                    </a> : <> </>}
                                <div className="d-flex justify-content-end align-items-center gap-2">
                                    <div>{address?.join(", ") || "Your City, Your Country"}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ca-layout-footer">
                    <div className='footer-shape' style={{ backgroundColor: layoutColor }}>{companyName}</div>
                </div>
            </div>

        </>
    )
}

const LayoutCa2 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address, userDetails } = layoutProps;

    return (
        <>
            <div className="layout-prof ca-layout-2" style={{ backgroundColor: "white" }}>
                <div className="ca-layout-upper flex-row-reverse py-2 px-2">
                    <div className='flex-center ps-1'>
                        <CAIndialogo />
                    </div>
                    <div className='preview-card-names'>
                        <h3 style={{ color: colorPrimary ?? "black" }}>{userDetails?.name}</h3>
                        <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {companyName + " - " + designation}</h5>
                    </div>
                </div>
                <div className="ca-layout-body px-2">
                    <div className="d-flex flex-row-reverse justify-content-between">
                        <div className="flex-center">
                            <div>
                                <QrCodeCard CARDNAME_id={cardType} size={100} />
                            </div>
                        </div>
                        <div>
                            <div className="d-flex flex-column justify-content-end py-3 ps-2">
                                <div className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                    <div>{phoneNo}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PhoneIphoneRoundedIcon className='ca-contact-svg' /> </div>
                                </div>
                                <div className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                    <div>{emailId}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                </div>
                                {(website && website?.visible) ?
                                    <a href={website?.url} target="_blank" rel="noreferrer"
                                        className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2"
                                        style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}>
                                        <div>My Website</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='ca-contact-svg' /></div>
                                    </a> : <> </>}
                                {address?.length > 0 ?
                                    <div className="d-flex flex-row-reverse justify-content-end align-items-center gap-2">
                                        <div>{address.join(", ")}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                    </div> : <> </>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ca-layout-footer">
                    <div className='footer-shape' style={{ backgroundColor: layoutColor }}>{companyName}</div>
                </div>
            </div>
        </>
    )
}

const LayoutHr1 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, colorTitle, bgColor, layoutColor, labelColor, phoneNo, emailId, address } = layoutProps;

    return (<>
        <div className="layout-prof hr-layout-1">
            <div className="row gx-0">
                <div className="col-6 col-xl-5" style={{ backgroundColor: "#3C4048" }}>
                    <div className="flex-center h-100pc">
                        <div className="hr-image-container" style={{ borderColor: layoutColor }}>
                            <div className='hr-image-div' >
                                <img src={profilePicture} alt='profile' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-6 col-xl-7" style={{ backgroundColor: "#F4F4F4" }}>
                    <div className="hr-layout-right word-break py-2">
                        <div className='preview-card-names word-break px-3' >
                            <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                            <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {companyName + " - " + designation}</h5>
                        </div>
                        <div className="hr-info-box">
                            <div className="hr-info-wrapper">
                                <div className="hr-info-property" style={{ color: colorTitle ?? "black" }}>Contact</div>
                                <div className="hr-info-value">{phoneNo}</div>
                            </div>
                            <div className="hr-info-wrapper">
                                <div className="hr-info-property" style={{ color: colorTitle ?? "black" }}>E-mail</div>
                                <div className="hr-info-value">{emailId}</div>
                            </div>
                            {address?.length > 0 ?
                                <div className="hr-info-wrapper">
                                    <div className="hr-info-property" style={{ color: colorTitle ?? "black" }}>Address</div>
                                    <div className="hr-info-value">{address.join(", ")}</div>
                                </div> : <> </>}
                            <div className="hr-info-icons-bar py-3 px-2" style={{ backgroundColor: layoutColor }}>
                                <div className="hr-info-icon" style={{ backgroundColor: bgColor }}><CallRoundedIcon className='hr-info-svg' style={{ color: layoutColor }} /></div>
                                <div className="hr-info-icon" style={{ backgroundColor: bgColor }}><EmailRounded className='hr-info-svg' style={{ color: layoutColor }} /></div>
                                <div className="hr-info-icon" style={{ backgroundColor: bgColor }}><LocationOnRoundedIcon className='hr-info-svg' style={{ color: layoutColor }} /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>
    )

}

const LayoutHr2 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, colorTitle, bgColor, layoutColor, labelColor, phoneNo, emailId, address } = layoutProps;

    return (<>
        <div className="layout-prof hr-layout-2" style={{ backgroundColor: "white" }}>
            <div className="row gx-0 h-100pc" >
                <div className="col-5 py-3" style={{ backgroundColor: "#24252f" }}>
                    <div className="flex-center flex-column">
                        <div className='preview-card-names word-break text-center'>
                            <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                            <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation} </h5>
                            <div className='hr-decor-line' style={{ backgroundColor: layoutColor }} />
                        </div>
                        <div className="hr-image-container text-center">
                            <div className='hr-image-div'>
                                <img src={!companyLogo?.data ? companyLogo : companyLogo?.data} alt='profile' />
                            </div>
                            <h5 className='my-1' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)", fontSize: "14px" }}>{companyName}</h5>
                        </div>
                    </div>
                </div>
                <div className="col-7 p-3 d-flex align-items-center">
                    <div className="hr-info-box ps-2">
                        <div className="hr-info-wrapper" style={{ borderBottom: `1px solid ${layoutColor}` }}>
                            <div className="hr-info-value">{phoneNo}</div>
                        </div>
                        <div className="hr-info-wrapper" style={{ borderBottom: `1px solid ${layoutColor}` }}>
                            <div className="hr-info-value">{emailId}</div>
                        </div>
                        {(address?.length > 0) ?
                            <div className="hr-info-wrapper">
                                <div className="hr-info-value">{address.join(", ")}</div>
                            </div> : <> </>}
                        <div className='shape-outer-1' /*style={{backgroundColor: bgColor, backgroundImage: `url(${HrOuterShape1})`}}*/> <HrOuterShape1 color={layoutColor} /> </div>
                        <div className='shape-outer-2' /*style={{backgroundColor: bgColor, backgroundImage: `url(${HrOuterShape2})`}}*/> <HrOuterShape1 color={layoutColor} /> </div>
                        <div className='shape-inner hr-info-icons-bar' style={{ backgroundImage: `url(${HrInnerShape})` }}>
                            <div className="hr-info-icon"><CallRoundedIcon className='hr-info-svg' style={{ color: layoutColor }} /></div>
                            <div className="hr-info-icon"><EmailRounded className='hr-info-svg' style={{ color: layoutColor }} /></div>
                            {(address?.length > 0) ? <div className="hr-info-icon"><LocationOnRoundedIcon className='hr-info-svg' style={{ color: layoutColor }} /></div> : <> </>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}

const LayoutBank1 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address } = layoutProps;

    return (
        <>
            <div className="layout-prof bank-layout-1" style={{ backgroundColor: "white" }}>
                <div className="bank-layout-upper d-flex justify-content-between py-2">
                    <div className='upper-left flex-center mx-1' >
                        <img src={!companyLogo?.data ? companyLogo : companyLogo?.data} alt='Company Logo' />
                    </div>
                    <div className='preview-card-names word-break px-3' style={{ textAlign: "right" }}>
                        <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                        <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                    </div>
                </div>
                <div className="ca-layout-body">
                    <div className="d-flex flex-row-reverse justify-content-between py-1">
                        <div className="flex-center ca-layout-left">
                            <div>
                                <QrCodeCard CARDNAME_id={cardType} size={100} />
                            </div>
                        </div>
                        <div className='ca-layout-right'>
                            <div className="d-flex flex-column justify-content-end py-3 ps-2">
                                <div className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                    <div>{phoneNo}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PhoneIphoneRoundedIcon className='ca-contact-svg' /> </div>
                                </div>
                                <div className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                    <div>{emailId}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                </div>
                                {(website && website?.visible) ?
                                    <a href={website?.url} target='_blank' rel='noreferrer'
                                        style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}
                                        className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                        <div>My Website</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='ca-contact-svg' /></div>
                                    </a> : <> </>}
                                {(address?.length > 0) ?
                                    <div className="d-flex flex-row-reverse justify-content-end align-items-center gap-2">
                                        <div>{address.join(", ")}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                    </div> : <> </>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

const LayoutBank2 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address } = layoutProps;

    return (
        <>
            <div className="layout-prof bank-layout-2" style={{ backgroundColor: "white" }}>
                <div className="bank-layout-upper d-flex justify-content-between py-2">
                    <div className='flex-center mx-1 upper-left'>
                        <img src={!companyLogo?.data ? companyLogo : companyLogo?.data} alt='Company Logo' />
                    </div>
                    <div className="d-flex flex-column align-items-end justify-content-end">
                        {
                            [0, 1, 2, 3, 4].map(index => (
                                <div key={index} style={{ width: `${90 + index * 6}px`, height: "1px", backgroundColor: "black", marginBottom: "4px" }}></div>
                            ))
                        }
                    </div>
                </div>
                <div className="ca-layout-body">
                    <div className="d-flex flex-row-reverse justify-content-between py-1">
                        <div className="flex-center ca-layout-left">
                            <div>
                                <QrCodeCard CARDNAME_id={cardType} size={100} />
                            </div>
                        </div>
                        <div className='ca-layout-right'>
                            <div className='preview-card-names word-break ps-2'>
                                <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                            </div>
                            <div className="d-flex flex-column justify-content-end p-2">
                                <div className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                    <div>{phoneNo}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PhoneIphoneRoundedIcon className='ca-contact-svg' /> </div>
                                </div>
                                <div className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2">
                                    <div>{emailId}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                </div>
                                {(website && website?.visible) ?
                                    <a href={website?.url} target='_blank' rel='noreferrer'
                                        className="d-flex flex-row-reverse justify-content-end align-items-center mb-2 gap-2"
                                        style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}>
                                        <div>My website</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='ca-contact-svg' /></div>
                                    </a> : <> </>}
                                {address?.length > 0 ?
                                    <div className="d-flex flex-row-reverse justify-content-end align-items-center gap-2">
                                        <div>{address.join(", ")}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                    </div> : <> </>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

const LayoutFl1 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address } = layoutProps;

    return (
        <>
            <div className="layout-prof freelancer-layout-1" style={{ background: `linear-gradient(0deg, ${bgColor}, ${layoutColor})` }}>
                <div className='freelancer-polygon left-shape' />
                <div className='freelancer-polygon right-shape' />
                <div className="row gx-0" >
                    <div className="col-5 flex-center">
                        <div className='flex-center fl-layout-logo-container' style={{ borderColor: colorSecondary }}>
                            <div className='flex-center fl-logo-div'>
                                <img src={!companyLogo?.data ? companyLogo : companyLogo?.data} />
                            </div>
                        </div>
                    </div>
                    <div className="col-7">
                        <div className='fl-layout-right'>
                            <div className='preview-card-names word-break'>
                                <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                            </div>
                            <div>
                                <div className="d-flex flex-column py-3 pe-2" style={{ textAlign: "left" }}>
                                    <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                        <div>{phoneNo}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <CallRoundedIcon className='ca-contact-svg' /> </div>
                                    </div>
                                    <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                        <div>{emailId}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                    </div>
                                    {(website && website?.url) ?
                                        <a href={website?.url} target='_blank' rel='noreferrer'
                                            style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}
                                            className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                            <div>My Website</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='ca-contact-svg' /></div>
                                        </a> : <> </>}
                                    {address?.length > 0 ?
                                        <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                            <div>{address.join(", ")}</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                        </div> : <> </>}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const LayoutFl2 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address } = layoutProps;

    return (
        <>
            <div className="layout-prof freelancer-layout-2" style={{ background: `linear-gradient(0deg, ${bgColor}, ${layoutColor})` }}>
                <div className='freelancer-polygon left-shape' />
                <div className='freelancer-polygon right-shape flex-center'>
                    <div className='flex-center fl-layout-logo-container'>
                        <img src={!companyLogo?.data ? companyLogo : companyLogo?.data} />
                    </div>
                </div>
                <div className="row gx-0">
                    <div className="col-8">
                        <div className='word-break fl-layout-left'>
                            <div className='preview-card-names word-break'>
                                <h3 style={{ color: colorPrimary ?? "black", }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                            </div>
                            <div>
                                <div className="d-flex flex-column py-3 pe-2" style={{ textAlign: "left" }}>
                                    <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                        <div>{phoneNo}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <CallRoundedIcon className='ca-contact-svg' /> </div>
                                    </div>
                                    <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                        <div>{emailId}</div>
                                        <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                                    </div>
                                    {(website && website.visible) ?
                                        <a href={website?.url} target='_blank' rel='noreferrer'
                                            style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}
                                            className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                            <div>My Website</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='ca-contact-svg' /></div>
                                        </a> : <> </>}
                                    {(address?.length > 0) ?
                                        <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                            <div>{address.join(", ")}</div>
                                            <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                        </div> : <> </>}
                                </div>
                            </div>

                        </div>
                    </div>
                    {/* <div className="col-5 flex-center">
                        <div className='flex-center' style={{ width: "100%", height: "60%", borderRight: "1px solid white" }}>
                            <div className='flex-center' style={{ maxHeight: "60%", maxWidth: "60%" }}>
                                <img src={companyLogo} style={{ height: "100%", width: "100%", objectFit: "contain" }} />
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    )
}

const LayoutCs1 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, address } = layoutProps;

    return (
        <>
            <div className="layout-prof cs-layout-1 px-4" style={{ backgroundColor: bgColor }}>
                <div className="cs-layout-upper d-flex align-items-center pt-2">
                    <div className="cs-layout-logo-container pe-2">
                        <img src={!companyLogo?.data ? companyLogo : companyLogo?.data} alt="Company Logo" />
                    </div>
                    <span>{companyName}</span>
                </div>
                <div className="row gx-0">
                    <div className="col-8">
                        <div className='preview-card-names word-break pt-3'>
                            <h3 className='mb-1' style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                        </div>
                        <div className="d-flex flex-column py-3" style={{ textAlign: "left" }}>
                            <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                <div>{phoneNo}</div>
                                <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <CallRoundedIcon className='ca-contact-svg' /> </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                <div>{emailId}</div>
                                <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='ca-contact-svg' /> </div>
                            </div>
                            {(address?.length > 0) ?
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                    <div>{address.join(", ")}</div>
                                    <div className='ca-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' /></div>
                                </div> : <> </>}
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="flex-center">
                            <div className="cs-image-container">
                                <div className='cs-image-div'>
                                    <img src={profilePicture} alt='profile' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const LayoutCs2 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address } = layoutProps;

    return (
        <>
            <div className="layout-prof cs-layout-2 px-3" style={{ backgroundColor: bgColor }}>
                <div className="row gx-0">
                    <div className="col-5">
                        <div className="cs-layout-left">
                            <div className="rhombus-clip hr-image-wrapper flex-center" style={{ backgroundColor: layoutColor }}>
                                <div className='rhombus-clip cs-image-container'>
                                    <img src={profilePicture} alt='profile' />
                                </div>
                            </div>
                        </div>
                        <div className='rhombus-clip cs-shape-full top' style={{ backgroundColor: layoutColor }} />
                        <div className='rhombus-clip cs-shape-full bottom' style={{ backgroundColor: layoutColor }} />
                        <div className='rhombus-clip cs-shape-full top-corner' style={{ backgroundColor: layoutColor }} />
                        <div className='rhombus-clip cs-shape-full bottom-corner' style={{ backgroundColor: layoutColor }} />
                        <div className='iso-triangle-clip cs-shape-partial top' style={{ backgroundColor: layoutColor }} />
                        <div className='iso-triangle-clip cs-shape-partial bottom' style={{ backgroundColor: layoutColor }} />
                        <div className='rhombus-clip cs-shape-small top' style={{ backgroundColor: layoutColor }} />
                        <div className='rhombus-clip cs-shape-small bottom' style={{ backgroundColor: layoutColor }} />
                    </div>
                    <div className="col-7">
                        <div className='cs-layout-right word-break'>
                            <div className='preview-card-names word-break pt-3'>
                                <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                                <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {companyName + " - " + designation}</h5>
                            </div>
                            <div className="d-flex flex-column justify-content-end py-3 pe-2">
                                <div className="d-flex justify-content-end align-items-top mb-2 gap-2">
                                    <div>{phoneNo}</div>
                                    <div className='ca-contact-icon' style={{ borderColor: layoutColor }}> <CallRoundedIcon className='ca-contact-svg' style={{ color: layoutColor }} /> </div>
                                </div>
                                <div className="d-flex justify-content-end align-items-top mb-2 gap-2">
                                    <div>{emailId}</div>
                                    <div className='ca-contact-icon' style={{ borderColor: layoutColor }}> <EmailRounded className='ca-contact-svg' style={{ color: layoutColor }} /> </div>
                                </div>
                                {(website && website.visible) ?
                                    <a href={website?.url} target='_blank' rel='noreferrer'
                                        style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}
                                        className="d-flex justify-content-end align-items-top mb-2 gap-2">
                                        <div>My Website</div>
                                        <div className='ca-contact-icon' style={{ borderColor: layoutColor }}> <PublicIcon className='ca-contact-svg' style={{ color: layoutColor }} /></div>
                                    </a> : <> </>}
                                {(address?.length > 0) ?
                                    <div className="d-flex justify-content-end align-items-top gap-2">
                                        <div>Your Address</div>
                                        <div className='ca-contact-icon' style={{ borderColor: layoutColor }}> <LocationOnRoundedIcon className='ca-contact-svg' style={{ color: layoutColor }} /></div>
                                    </div> : <> </>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const LayoutIt1 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website } = layoutProps;

    return (
        <>
            <div className="layout-prof it-layout-1 p-5" style={{ backgroundColor: bgColor }}>
                <ITGridShape1 className='it-layout-shape shape-1' />
                <ITGridShape2 className='it-layout-shape shape-2' />
                <ITGridShape3 className='it-layout-shape shape-3' />
                <ITGridShape4 className='it-layout-shape shape-4' />
                <ITGridShape5 className='it-layout-shape shape-5' />
                <div>
                    <center className='word-break'>
                        <div className='preview-card-names word-break text-center'>
                            <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                            <h5 className='mb-1' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                            <div className='it-names-underline' style={{ backgroundColor: layoutColor }} />
                        </div>

                        <div className="it-contacts-container d-flex flex-column py-3">
                            <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                <div className='itech-contact-value'>{phoneNo}</div>
                                <div className='itech-contact-icon'> <CallRoundedIcon className='itech-contact-svg' style={{ color: layoutColor }} /> </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                <div className='itech-contact-value'>{emailId}</div>
                                <div className='itech-contact-icon'> <EmailRounded className='itech-contact-svg' style={{ color: layoutColor }} /> </div>
                            </div>
                            {(website && website?.visible) ?
                                <a href={website?.url} target='_blank' rel='noreferrer'
                                    style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}
                                    className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                    <div className='itech-contact-value'>My Website</div>
                                    <div className='itech-contact-icon'> <PublicIcon className='itech-contact-svg' style={{ color: layoutColor }} /></div>
                                </a> : <> </>}
                        </div>
                    </center>
                </div>
            </div>
        </>
    )
}

const LayoutIt2 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website, address } = layoutProps;

    const cardRef = useRef(null);
    const rightShapeRef = useRef(null);

    useEffect(() => {
        const adjustShapeHeight = () => {
            const cardHeight = cardRef.current.offsetHeight;
            const shapeHeight = cardHeight * 1.26; // Adjust this multiplier based on your design requirements
            rightShapeRef.current.style.height = `${shapeHeight}px`;
        };

        adjustShapeHeight();

        window.addEventListener('resize', adjustShapeHeight);
        return () => window.removeEventListener('resize', adjustShapeHeight);
    }, []);

    return (
        <>
            <div className="layout-prof it-layout-2" ref={cardRef} style={{ backgroundColor: bgColor }}>
                <div className="row gx-0">
                    <div className="col-7 it-layout-left">
                        <div className='preview-card-names word-break'>
                            <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                            <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                        </div>
                        <div className="it-contacts-container d-flex flex-column py-3">
                            <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                <div className='itech-contact-value'>{phoneNo}</div>
                                <div className='itech-contact-icon'> <CallRoundedIcon className='itech-contact-svg' style={{ color: layoutColor }} /> </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                <div className='itech-contact-value'>{emailId}</div>
                                <div className='itech-contact-icon'> <EmailRounded className='itech-contact-svg' style={{ color: layoutColor }} /> </div>
                            </div>
                            {(website && website?.visible) ?
                                <a href={website?.url} target='_blank' rel='noreferrer'
                                    style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}
                                    className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                    <div className='itech-contact-value'>My Website</div>
                                    <div className='itech-contact-icon'> <PublicIcon className='itech-contact-svg' style={{ color: layoutColor }} /></div>
                                </a> : <> </>}
                            {(address?.length > 0) ? <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                <div className='itech-contact-value'>{address.join(", ")}</div>
                                <div className='itech-contact-icon'> <LocationOnRoundedIcon className='itech-contact-svg' style={{ color: layoutColor }} /></div>
                            </div> : <> </>}
                        </div>

                    </div>
                    <div className="col-5 it-layout-right flex-center">
                        <div className="it-point-left-shape" ref={rightShapeRef} style={{ background: `linear-gradient(135deg, ${layoutColor}, transparent)` }} >
                            <div className='inner-shape flex-center' style={{ backgroundColor: bgColor }} >
                                <div className='it-company-info flex-center flex-column' >
                                    <div className='it-company-logo' style={{ maxHeight: "60px", maxWidth: "60px", overflow: "hidden" }}>
                                        <img src={!companyLogo?.data ? companyLogo : companyLogo?.data} alt='Company Logo' style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                    </div>
                                    <span className='my-1' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}>{companyName}</span>
                                </div>
                            </div>
                        </div>
                        {/* <div className='flex-center flex-column' style={{position: "relative", left: "10px", top: "8px", zIndex: 5}}>
                                <div style={{maxHeight: "60px", maxWidth: "60px", overflow: "hidden"}}>
                                    <img src={companyLogo} alt='Company Logo' style={{width: "100%", height: "100%", objectFit: "contain"}} />
                                </div>
                                <h5 className='my-1' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)", fontSize: "12px" }}>{companyName}</h5>
                            </div> */}
                    </div>
                    <div className="it-point-up-shape" style={{ background: `linear-gradient(135deg, ${layoutColor}, transparent)` }} >
                        <div className='inner-shape' style={{ backgroundColor: bgColor }} />
                    </div>
                </div>
            </div>
        </>
    )
}

const LayoutAdv1 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website } = layoutProps;

    return (
        <>
            <div className="layout-prof adv-layout-1" style={{ backgroundColor: bgColor }}>
                <div className='d-flex'>
                    <div className='adv-shapes-cluster'>
                        <div className="adv-layout-polygon flex-center" style={{ backgroundColor: layoutColor }}>
                            <div className="adv-layout-polygon-content">
                                <div className='adv-layout-logo-container' >
                                    <img src={!companyLogo?.data ? companyLogo : companyLogo?.data} alt='Company Logo' />
                                </div>
                            </div>
                        </div>
                        <BottomLight className='adv-bottom-light' />
                        <BottomBold className='adv-bottom-bold' />
                        <TopLight className='adv-top-light' />
                        <TopBold className='adv-top-bold' />
                    </div>
                    <div className='adv-layout-body py-5 px-3'>
                        <div className='preview-card-names word-break' style={{ textAlign: "right" }}>
                            <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                            <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {companyName + " - " + designation}</h5>
                        </div>
                        <div className="adv-contact-container d-flex flex-column py-3">
                            <div className="d-flex justify-content-end align-items-top mb-2 gap-2">
                                <div className='itech-contact-value'>{phoneNo}</div>
                                <div className='adv-contact-icon' style={{ backgroundColor: layoutColor }}> <CallRoundedIcon className='adv-contact-svg' style={{ color: bgColor }} /> </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-top mb-2 gap-2">
                                <div className='itech-contact-value'>{emailId}</div>
                                <div className='adv-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='adv-contact-svg' style={{ color: bgColor }} /> </div>
                            </div>
                            {(website && website?.visible) ?
                                <a href={website?.url} target='_blank' rel='noreferrer'
                                    style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}
                                    className="d-flex justify-content-end align-items-top gap-2">
                                    <div className='itech-contact-value'>My Website</div>
                                    <div className='adv-contact-icon' style={{ backgroundColor: layoutColor }}> <PublicIcon className='adv-contact-svg' style={{ color: bgColor }} /> </div>
                                </a> : <> </>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const LayoutAdv2 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, website } = layoutProps;

    return (
        <>
            <div className="layout-prof adv-layout-2" style={{ backgroundColor: bgColor }}>
                <div className='d-flex'>
                    <div className='adv-layout-left'>
                        <div className='adv-img-container'>
                            <img src={profilePicture} alt='Profile' />
                        </div>
                    </div>
                    <div className='adv-layout-body word-break' style={{ width: "65%" }}>
                        <div className='border-with-text preview-card-names word-break' style={{ borderColor: layoutColor }}>
                            <h3 style={{ color: colorPrimary ?? "black", fontSize: "16px", marginBottom: "4px", width: "fit-content", paddingLeft: "5px" }}>
                                <div className='d-flex'>{prefix}</div>
                                <div className='d-flex'>{firstName}</div>
                                <div className='d-flex'>{lastName}</div>
                                <div className='d-flex'>{suffix}</div>
                            </h3>
                            <h5 className='text-on-border' style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)", backgroundColor: bgColor }}> {designation}</h5>
                        </div>
                        <div className="adv-contact-container d-flex flex-column pt-3" style={{ fontSize: "12px" }}>
                            <div className='itech-contact-value mb-1'>Your Address</div>
                            <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                <div className='itech-contact-value'>{phoneNo}</div>
                                <div className='itech-contact-icon'> <CallRoundedIcon className='itech-contact-svg' style={{ color: layoutColor }} /> </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                <div className='itech-contact-value'>{emailId}</div>
                                <div className='itech-contact-icon'> <EmailRounded className='itech-contact-svg' style={{ color: layoutColor }} /> </div>
                            </div>
                            {(website && website?.visible) ?
                                <a href={website?.url} target='_blank' rel='noreferrer'
                                    style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}
                                    className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                    <div className='itech-contact-value'>My Website</div>
                                    <div className='itech-contact-icon'> <PublicIcon className='itech-contact-svg' style={{ color: layoutColor }} /></div>
                                </a> : <> </>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const LayoutDr1 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, address } = layoutProps;

    return (
        <>
            <div className="layout-prof dr-layout-1" style={{ backgroundColor: bgColor }}>
                <div className="row gx-0">
                    <div className="col-6 dr-layout-left word-break">
                        <div className='preview-card-names word-break'>
                            <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                            <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                        </div>
                        <div className="dr-contact-container d-flex flex-column py-3">
                            <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                <div className='dr-contact-value'>{phoneNo}</div>
                                <div className='dr-contact-icon' style={{ backgroundColor: layoutColor }}> <CallRoundedIcon className='dr-contact-svg' style={{ color: bgColor }} /> </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                <div className='dr-contact-value'>{emailId}</div>
                                <div className='dr-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='dr-contact-svg' style={{ color: bgColor }} /> </div>
                            </div>
                            {(address?.length > 0) ?
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                    <div className='dr-contact-value'>{address.join(", ")}</div>
                                    <div className='dr-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='dr-contact-svg' style={{ color: bgColor }} /></div>
                                </div> : <> </>}
                        </div>
                    </div>
                    <div className="col-6 dr-layout-right">
                        <div className='dr-profile-shapes-wrapper'>
                            <div className='parallelogram-clip dr-profile-container' >
                                <img className='dr-profile-pic' src={profilePicture} alt='profile' />
                            </div>
                            <div className="dr-shape-top-left" style={{ backgroundColor: layoutColor }} />
                            <div className="parallelogram-clip dr-shape-bottom-right" style={{ backgroundColor: colorPrimary }} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const LayoutDr2 = ({ layoutProps }) => {
    const { profilePicture, cardType, companyLogo, prefix, suffix, firstName, lastName,
        companyName, designation, title, colorPrimary,
        colorSecondary, bgColor, layoutColor, labelColor, phoneNo, emailId, address } = layoutProps;

    return (
        <>
            <div className="layout-prof dr-layout-2" style={{ backgroundColor: bgColor }}>
                <div className="row gx-0">
                    <div className="col-6 dr-layout-left-up word-break">
                        <div className='preview-card-names word-break' >
                            <h3 style={{ color: colorPrimary ?? "black" }}>{prefix}{" "}{firstName}{" "}{lastName}{""}{suffix}</h3>
                            <h5 style={{ color: colorSecondary ?? "rgb(0, 0, 0, 0.6)" }}> {designation}</h5>
                        </div>
                    </div>
                    <div className="row gx-0">
                        <div className="col-7 dr-layout-left-down word-break">
                            <div className="d-flex flex-column py-3 dr-contact-container" >
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                    <div className='dr-contact-value'>{phoneNo}</div>
                                    <div className='dr-contact-icon' style={{ backgroundColor: layoutColor }}> <CallRoundedIcon className='dr-contact-svg' style={{ color: bgColor }} /> </div>
                                </div>
                                <div className="d-flex justify-content-end align-items-top flex-row-reverse mb-2 gap-2">
                                    <div className='dr-contact-value'>{emailId}</div>
                                    <div className='dr-contact-icon' style={{ backgroundColor: layoutColor }}> <EmailRounded className='dr-contact-svg' style={{ color: bgColor }} /> </div>
                                </div>
                                {(address?.length > 0) ?
                                    <div className="d-flex justify-content-end align-items-top flex-row-reverse gap-2">
                                        <div className='dr-contact-value'>{address.join(", ")}</div>
                                        <div className='dr-contact-icon' style={{ backgroundColor: layoutColor }}> <LocationOnRoundedIcon className='dr-contact-svg' style={{ color: bgColor }} /></div>
                                    </div> : <> </>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='dr-profile-shapes-wrapper'>
                    <div className='custom-polygon dr-profile-container' >
                        <img src={profilePicture} alt='profile' style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    </div>
                    <div className="custom-shape" style={{ backgroundColor: layoutColor }} />
                </div>
            </div>
        </>
    )
}

export const renderLayout = (layoutStyle, layoutProps) => {



    switch (layoutStyle) {
        case '1':
            return <Layout1 layoutProps={layoutProps} />;
        case '3':
            return <Layout3 layoutProps={layoutProps} />;
        case '5':
            return <Layout5 layoutProps={layoutProps} />;
        case '7':
            return <Layout7 layoutProps={layoutProps} />;
        case '2':
            return <Layout2 layoutProps={layoutProps} />;
        case '4':
            return <Layout4 layoutProps={layoutProps} />;
        case '6':
            return <Layout6 layoutProps={layoutProps} />;
        case '8':
            return <Layout8 layoutProps={layoutProps} />;
        case 'ca1':
            return <LayoutCa1 layoutProps={layoutProps} />;
        case 'ca2':
            return <LayoutCa2 layoutProps={layoutProps} />;
        case 'hr1':
            return <LayoutHr1 layoutProps={layoutProps} />;
        case 'hr2':
            return <LayoutHr2 layoutProps={layoutProps} />;
        case 'bk1':
            return <LayoutBank1 layoutProps={layoutProps} />;
        case 'bk2':
            return <LayoutBank2 layoutProps={layoutProps} />;
        case 'fl1':
            return <LayoutFl1 layoutProps={layoutProps} />;
        case 'fl2':
            return <LayoutFl2 layoutProps={layoutProps} />;
        case 'cs1':
            return <LayoutCs1 layoutProps={layoutProps} />;
        case 'cs2':
            return <LayoutCs2 layoutProps={layoutProps} />;
        case 'it1':
            return <LayoutIt1 layoutProps={layoutProps} />;
        case 'it2':
            return <LayoutIt2 layoutProps={layoutProps} />;
        case 'adv1':
            return <LayoutAdv1 layoutProps={layoutProps} />;
        case 'adv2':
            return <LayoutAdv2 layoutProps={layoutProps} />;
        case 'dr1':
            return <LayoutDr1 layoutProps={layoutProps} />;
        case 'dr2':
            return <LayoutDr2 layoutProps={layoutProps} />;
        default:
            return <></>;
    }
};